var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-view',{staticStyle:{"padding":"12px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }